export class CacheDuration {
  static tenSeconds = 1000 * 10; //  milliseconds for testing
  static thirtySeconds = 1000 * 30; //  milliseconds for testing

  static twoMinute = 60000 * 2; //  milliseconds
  static fiveMinute = 60000 * 5;
  static tenMinute = 60000 * 10;
  static fifteenMinute = 60000 * 15;
  static thirtyMinute = 60000 * 30;
  static oneHour = 60000 * 60;
}
